import { Type } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, IsUrl, ValidateNested } from 'class-validator';
import { EntityStateSchemaDto } from '../../@base';
import { FileId } from '../../types';
import { UserCreatedByPopulateDto } from '../users/populate/user-created-by-populate.dto';
import { FileProviderMetadataDto } from './file-metadata.dto';
import { FilePurpose } from './file-purpose.enum';
import { FileThumbnailsDto } from './file-thumbnail.dto';

export class FileAdminDto extends EntityStateSchemaDto<FileId> {
  @IsString()
  @IsNotEmpty()
  filename!: string;

  @IsString()
  @IsNotEmpty()
  mimeType!: string;

  @IsNumber()
  @IsNotEmpty()
  size!: number;

  @IsUrl()
  @IsNotEmpty()
  url!: string;

  @ValidateNested()
  @Type(() => UserCreatedByPopulateDto)
  @IsNotEmpty()
  uploadedBy!: UserCreatedByPopulateDto;

  @ValidateNested()
  @Type(() => FileProviderMetadataDto)
  @IsNotEmpty()
  metadata!: FileProviderMetadataDto;

  @ValidateNested()
  @Type(() => FileThumbnailsDto)
  @IsOptional()
  thumbnail?: FileThumbnailsDto;

  @IsEnum(FilePurpose)
  @IsNotEmpty()
  purpose!: FilePurpose;
}
